<div class="bot-container chat-container{{cssClass ? ' ' + cssClass : ''}}"
     [style.overflow-y]="overflowY ? 'auto' : 'hidden'" [style.max-height]="maxHeight"
     [style.padding-bottom]="paddingBottom + ' !important'">
  <ng-content></ng-content>
</div>
